import * as React from "react";

export const OrganisationTypeIcon = ({ ...props }) => {
  return (
    <svg width={17} height={18} viewBox="0 0 17 18" fill="none" {...props}>
      <g
        opacity={0.3}
        stroke="#214160"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8.334 11a2 2 0 100-4 2 2 0 000 4z" />
        <path d="M13.267 11a1.1 1.1 0 00.22 1.213l.04.04a1.335 1.335 0 11-1.887 1.887l-.04-.04a1.1 1.1 0 00-1.213-.22 1.1 1.1 0 00-.667 1.006V15a1.333 1.333 0 11-2.667 0v-.06a1.1 1.1 0 00-.72-1.007 1.1 1.1 0 00-1.213.22l-.04.04a1.334 1.334 0 11-1.887-1.886l.04-.04a1.1 1.1 0 00.22-1.214 1.1 1.1 0 00-1.006-.667h-.114a1.333 1.333 0 010-2.666h.06A1.1 1.1 0 003.4 7a1.1 1.1 0 00-.22-1.213l-.04-.04A1.333 1.333 0 115.027 3.86l.04.04a1.1 1.1 0 001.213.22h.053A1.1 1.1 0 007 3.113V3a1.333 1.333 0 012.667 0v.06a1.1 1.1 0 00.666 1.006 1.1 1.1 0 001.214-.22l.04-.04a1.333 1.333 0 012.277.944 1.333 1.333 0 01-.39.943l-.04.04a1.1 1.1 0 00-.22 1.214V7a1.1 1.1 0 001.006.667h.113a1.333 1.333 0 110 2.666h-.06a1.1 1.1 0 00-1.006.667v0z" />
      </g>
    </svg>
  );
};
